<template>
  <div id="user-index">
    <div id="page-head">
      <ul id="breadcrumbs">
        <li>
          <router-link :to="{ name: 'Dashboard' }">Dashboard</router-link>
        </li>
        <li>Users</li>
      </ul>
    </div>

    <div class="panel">
      <div class="panel-head">
        <h2>Users</h2>

        <ul class="actions">
          <li>
            <button @click="showUserCreate = true" class="action">Add User</button>
          </li>
        </ul>
      </div>

      <div class="panel-content">
        <table class="users">
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td class="icon-column">
                <span class="user-icon">
                  <img :src="getBambooImage(user)" />
                </span>
              </td>
              <td>
                <p class="name">
                  <router-link
                    :to="{ name: 'UserEdit', params: { userId: user.id }}"
                  >{{ user.first_name }} {{ user.last_name }}</router-link>
                </p>
                <p class="title">{{ user.title }}</p>
              </td>
              <td>
                <p class="role">{{ user.role.name }}</p>
              </td>
              <td>
                <p class="email">
                  <a :href="'mailto:'+user.email">{{ user.email }}</a>
                </p>
                <p class="phone">{{ user.phone }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <user-create :show="showUserCreate" @close="showUserCreate = false" @update="loadUsers()"></user-create>
  </div>
</template>

<script>
import UserCreate from "@/components/users/UserCreate";
import UserEdit from "@/components/users/UserEdit";
import md5 from "js-md5";

export default {
  name: "UserIndex",
  components: {
    UserEdit,
    UserCreate
  },
  data() {
    return {
      users: [],
      showUserCreate: false,
      showUserEdit: false
    };
  },
  created() {
    this.loadUsers();
  },
  methods: {
    loadUsers() {
      this.$http
        .get("/users")
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getBambooImage(user) {
      return (
        "https://trimark.bamboohr.com/employees/photos/?h=" + md5(user.email)
      );
    }
  }
};
</script>

<style lang="scss">
#user-index {
  .icon-column {
    width: 40px;
  }
  .user-icon {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 2px solid $medium-gray;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
    }
  }
  .name {
    font-weight: 600;
  }
  .role {
    font-weight: 600;
  }
}
</style>
